import React from 'react'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import { Inline, Text } from 'src/viewLayer/components/DesignSystem'
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink'
import safeLocalStorage from 'src/viewLayer/helpers/safeLocalStorage'
import { t } from 'src/viewLayer/helpers/translations'
import { useEmailPagePath } from 'src/viewLayer/navigation'

export default () => {
  const { devicePath } = useAppConfigContext()

  if (devicePath !== 'login') {
    return null
  }

  return (
    <Inline align="center" alignItems="center" gap={3}>
      <Text fontSize="small">{t('password.links.change_email_question')}</Text>
      <TrackableLink
        data-testid="change-email-link"
        href={useEmailPagePath()}
        onClick={() => safeLocalStorage.remove('email')}
        size="small"
        trackingId={'change_email_link'}
        weight="strong"
      >
        {t('password.links.change_email_action')}
      </TrackableLink>
    </Inline>
  )
}
